export type TemperatureCategory = 'cold' | 'optimal' | 'hot';
export type WindCategory = 'calm' | 'breeze' | 'strong';
export type PrecipitationCategory = 'none' | 'light' | 'heavy';

export interface WeatherThresholds {
  temperature: { coldMax: number; optimalMax: number };
  wind:        { calmMax: number; breezeMax: number };
  precipitation: { noneMax: number; lightMax: number };
}

export function bucketTemperature(value: number, t: WeatherThresholds): TemperatureCategory {
  if (value <= t.temperature.coldMax)    return 'cold';
  if (value <= t.temperature.optimalMax) return 'optimal';
  return 'hot';
}

export function bucketWind(value: number, t: WeatherThresholds): WindCategory {
  if (value <= t.wind.calmMax)   return 'calm';
  if (value <= t.wind.breezeMax) return 'breeze';
  return 'strong';
}

export function bucketPrecipitation(value: number, t: WeatherThresholds): PrecipitationCategory {
  if (value <= t.precipitation.noneMax)  return 'none';
  if (value <= t.precipitation.lightMax) return 'light';
  return 'heavy';
}

export interface WeatherEntry {
  timestamp: string;
  temp?: number;
  windSpeed?: number;
  precipitation?: number;
}

/**
 * Find the closest weather entry to `target` (an ISO timestamp). Returns null
 * if `entries` is empty or all entries are more than 48 hours away from target.
 */
export function findClosestWithin48h(
  entries: WeatherEntry[],
  target: string
): WeatherEntry | null {
  const targetMs = new Date(target).getTime();
  if (Number.isNaN(targetMs) || entries.length === 0) return null;
  const FORTY_EIGHT_H_MS = 48 * 60 * 60 * 1000;
  let best: WeatherEntry | null = null;
  let bestDelta = Infinity;
  for (const e of entries) {
    const t = new Date(e.timestamp).getTime();
    if (Number.isNaN(t)) continue;
    const delta = Math.abs(t - targetMs);
    if (delta <= FORTY_EIGHT_H_MS && delta < bestDelta) {
      best = e;
      bestDelta = delta;
    }
  }
  return best;
}
